import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const work = {
  global,
  path: paths.work,
  pathname: pathnames[paths.work],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          },
          {
            type: '',
            data: {

            }
          }
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          }
        ]
      }
    ]
  }
};
